import React, { useContext, useEffect, useState } from "react";
import Tab from "../components/Tab";
import { useLocation, useParams } from "react-router-dom";
import { UserContext } from '../components/MyContext';
import AppShell from "../components/AppShell";
import TabHK from "./Tab/TabHK";
import axios from "axios";
import config from "../config";
import { FaTasks } from "react-icons/fa";

function MeasureDetail() {
  const { years } = useParams();
  const { userData } = useContext(UserContext);
  const [measureHeads, setMeasureHeads] = useState([]);
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const num = queryParams.get("num");

  const fetchMeasureHead = async () => {
    try {
      const res = await axios.get(config.urlApi + '/measure');
      setMeasureHeads(res.data);
    } catch (err) {
      console.log(err.message);
    }
  };

  useEffect(() => {
    fetchMeasureHead();
  }, []);

  // กรองเฉพาะ measureHead ที่มี id ตรงกับ num
  const filteredMeasureHeads = measureHeads.filter(measureHead => parseInt(measureHead.id) === parseInt(num));
  const hasMeasureCategories = filteredMeasureHeads.some(
    (measureHead) => measureHead.categorymeasures?.length > 0
  );

  return (
    <AppShell
      page="measureDetail"
      expanded="is-expanded"
      contentPreset="form"
      title={`กรอกข้อมูลมาตรการ หน่วยงาน ${userData.facultyName || '-'} ปี ${years}`}
      subtitle="เลือกหมวดมาตรการด้านล่างเพื่อบันทึกข้อมูลรายปีและติดตามผลลัพธ์"
    >
      <div className="row">
        <div className="col-12">
          <div className="card">
            {filteredMeasureHeads.length > 0 && hasMeasureCategories ? (
              filteredMeasureHeads.map((measureHead, index) => (
                <Tab key={index} variant="detail" className="app-measure-tabset">
                  {
                    measureHead.categorymeasures.map((categorymeasure) => (
                      <div key={categorymeasure.id} label={`${categorymeasure.cate_name}`} tabIcon={<FaTasks />} tabSubtitle="หมวดมาตรการและแบบฟอร์มบันทึก">
                        <TabHK measureTitle={`${categorymeasure.id}`} />
                      </div>
                    ))
                  }
                </Tab>
              ))
            ) : (
              <div className="app-empty-state app-empty-state--top app-empty-state--measure">
                <div className="app-empty-state__badge">ยังไม่มีข้อมูลมาตรการ</div>
                <h3 className="app-empty-state__title">ยังไม่มีแบบฟอร์มหรือรายการให้บันทึกในส่วนนี้</h3>
                <p className="app-empty-state__description">
                  ระบบยังไม่พบหมวดมาตรการที่พร้อมใช้งานสำหรับปีนี้ หรือยังไม่มีการกำหนดรายการแบบฟอร์มในส่วนนี้
                  เช่น มาตรการอื่น ๆ หรือมาตรการลดการใช้กระดาษ
                </p>
                <p className="app-empty-state__hint">
                  เมื่อมีการตั้งค่าข้อมูลจากระบบแล้ว รายการแบบฟอร์มจะปรากฏที่หน้านี้โดยอัตโนมัติ
                </p>
              </div>
            )}
          </div>
        </div>
      </div>
    </AppShell>
  );
}

export default MeasureDetail;
